'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var propColor = ['black', 'secondary', 'white'];
var propTarget = ['_self', '_blank', '_parent', '_top'];
exports.propColor = propColor;
exports.propTarget = propTarget;